"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinExchangeSubmitSchema = exports.MilkLinkageSchema = exports.MilkHistorySchema = exports.MilkHistoryRequestQuerySchema = exports.MilkExpirationSchema = exports.MilkExpirationRequestQuerySchema = exports.MilkExchangeSchema = exports.MilkExchangeRequestBodySchema = exports.MilkExchangeLimitSchema = exports.MilkBalanceSchema = exports.MilkDisconnectSchema = exports.MilkConnectSchema = exports.MilkConnectRequestBodySchema = void 0;
var zod_1 = require("zod");
var envelope_response_schema_1 = require("../utils/envelope-response-schema");
exports.MilkConnectRequestBodySchema = zod_1.z.object({
    verifyCode: zod_1.z.string().optional(),
});
exports.MilkConnectSchema = (0, envelope_response_schema_1.EnvelopeResponseSchema)(zod_1.z.object({ result: zod_1.z.string() }));
exports.MilkDisconnectSchema = (0, envelope_response_schema_1.EnvelopeResponseSchema)(zod_1.z.object({ result: zod_1.z.string() }));
exports.MilkBalanceSchema = (0, envelope_response_schema_1.EnvelopeResponseSchema)(zod_1.z.object({ totalBalance: zod_1.z.number() }));
exports.MilkExchangeLimitSchema = (0, envelope_response_schema_1.EnvelopeResponseSchema)(zod_1.z.object({
    minTryAmount: zod_1.z.number(),
    maxTryAmount: zod_1.z.number(),
    maxDayAmount: zod_1.z.number(),
    maxMonthAmount: zod_1.z.number(),
    maxDayCount: zod_1.z.number(),
    exchangedCoinDayAmount: zod_1.z.number(),
    exchangedCoinMonthAmount: zod_1.z.number(),
    exchangedCoinDayCount: zod_1.z.number(),
}));
exports.MilkExchangeRequestBodySchema = zod_1.z.object({
    amount: zod_1.z.number(),
});
exports.MilkExchangeSchema = (0, envelope_response_schema_1.EnvelopeResponseSchema)(zod_1.z.object({ totalPoint: zod_1.z.number(), totalCoin: zod_1.z.number(), exchangeCoin: zod_1.z.number() }));
exports.MilkExpirationRequestQuerySchema = zod_1.z.object({
    page: zod_1.z.string(),
    size: zod_1.z.string(),
    days: zod_1.z.string(),
});
exports.MilkExpirationSchema = (0, envelope_response_schema_1.EnvelopeResponseSchema)(zod_1.z.object({
    totalCount: zod_1.z.number(),
    totalPages: zod_1.z.number(),
    hasNext: zod_1.z.boolean(),
    totalToBeExpiredAmount: zod_1.z.number(),
    histories: zod_1.z.array(zod_1.z.object({
        actionType: zod_1.z.string(),
        originalAmount: zod_1.z.number(),
        toBeExpiredAmount: zod_1.z.number(),
        title: zod_1.z.string(),
        expiryAt: zod_1.z.string().nullable(),
        createdAt: zod_1.z.string(),
    })),
}));
exports.MilkHistoryRequestQuerySchema = zod_1.z.object({
    page: zod_1.z.string(),
    size: zod_1.z.string(),
    days: zod_1.z.string().optional(),
});
exports.MilkHistorySchema = (0, envelope_response_schema_1.EnvelopeResponseSchema)(zod_1.z.object({
    totalCount: zod_1.z.number(),
    totalPages: zod_1.z.number(),
    hasNext: zod_1.z.boolean(),
    histories: zod_1.z.array(zod_1.z.object({
        actionType: zod_1.z.string(),
        amount: zod_1.z.number(),
        title: zod_1.z.string(),
        expiryAt: zod_1.z.string().nullable(),
        createdAt: zod_1.z.string(),
    })),
}));
exports.MilkLinkageSchema = (0, envelope_response_schema_1.EnvelopeResponseSchema)(zod_1.z.object({ isLinked: zod_1.z.boolean() }));
exports.CoinExchangeSubmitSchema = zod_1.z.object({
    totalPoint: zod_1.z.number(),
    exchangeCoin: zod_1.z.number(),
    totalCoin: zod_1.z.number(),
});
